export type CustomerQueueVisibility = 'off' | 'status_only' | 'full';

export const DEFAULT_CUSTOMER_QUEUE_VISIBILITY: CustomerQueueVisibility = 'off';

export function normalizeCustomerQueueVisibility(raw: unknown): CustomerQueueVisibility {
  if (raw === 'off' || raw === 'status_only' || raw === 'full') return raw;
  return DEFAULT_CUSTOMER_QUEUE_VISIBILITY;
}
